import { render, staticRenderFns } from "./h5New.vue?vue&type=template&id=4b2d2d3d&scoped=true&"
import script from "./h5New.vue?vue&type=script&lang=js&"
export * from "./h5New.vue?vue&type=script&lang=js&"
import style0 from "./h5New.vue?vue&type=style&index=0&id=4b2d2d3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d2d3d",
  null
  
)

export default component.exports